import api from "./order-api"

export default {
  getAdressdaten: adressid => {
    return api.get(`/adressdaten/${adressid}`)
  },
}
